/* eslint-disable react/require-default-props */
import React from 'react';
import classNames from 'classnames';
import './HeaderFieldStyles.scss';
/**
 * HeaderField — label/value pair used inside a header's row slot (the
 * `fields` prop on `WorkspaceHeader` and `BrushawayHeader`). Encapsulates
 * the `header__field` wrapper, the `header__label` span, and the
 * auto-appended `:` so consumers don't repeat the markup at every call site.
 *
 * @example
 * <BrushawayHeader
 *   title="Deficiency"
 *   fields={(
 *     <>
 *       <HeaderField label="Status">
 *         <InlineSelect value={...} onChange={...} options={...} />
 *       </HeaderField>
 *       <HeaderField label="Reported">
 *         <InlineText>2026-05-22</InlineText>
 *       </HeaderField>
 *     </>
 *   )}
 * />
 */
export function HeaderField({ label, children, className }) {
    const wrapperClass = classNames('header__field', className);
    const renderedLabel = typeof label === 'string' ? `${label}:` : label;
    return (React.createElement("div", { className: wrapperClass },
        React.createElement("span", { className: "header__label" }, renderedLabel),
        children));
}
